module.exports = __webpack_public_path__ + "img/icon-arrow-right-featured.52643322.svg";